<template>
  <div class="group">
    <FormLabel v-if="label" :text="label" :for-id="selectId" :text-color-class="labelColorClass" :extra-class="labelClass" />
    <div class="relative">
      <select
        :id="selectId"
        :value="modelValue"
        :disabled="disabled"
        class="w-full appearance-none bg-white border border-[#1c4848]/10 rounded-2xl px-4 py-3 text-sm font-medium text-[#1c4848] focus:outline-none focus:border-[#1c4848]/30 focus:ring-4 focus:ring-[#1c4848]/5 shadow-sm cursor-pointer transition-all"
        @change="$emit('update:modelValue', $event.target.value)"
      >
        <option v-for="opt in options" :key="opt.value" :value="opt.value" :selected="opt.value === modelValue">
          {{ opt.label }}
        </option>
      </select>
      <div class="absolute right-3 top-3 pointer-events-none text-[#1c4848]">
        <i :class="arrowIconClass" class="text-lg block"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import FormLabel from '../Label.vue';

defineProps({
  modelValue: { type: [String, Number], default: '' },
  label: { type: String, default: '' },
  selectId: { type: String, default: '' },
  options: {
    type: Array,
    default: () => []
  },
  disabled: { type: Boolean, default: false },
  labelColorClass: { type: String, default: 'text-[#1c4848]/60' },
  labelClass: { type: String, default: '' },
  arrowIconClass: { type: String, default: 'pr pr-arrow-bottom-87we' }
});

defineEmits(['update:modelValue']);
</script>
